import * as yup from 'yup';

// List of valid parameters that can be used in the naming format
export const validParameters = [
  '{account}',
  '{type}',
  '{date}',
  '{contact}',
  '{year}',
  '{month}',
  '{category}',
  '{issuer}',
];

/**
 * Validates that at least one parameter is used in the naming format
 */
export const atLeastOneParameterValidator = {
  name: 'at-least-one-parameter',
  message: 'At least one parameter must be used in the format',
  test: (value: string | undefined) => {
    if (!value) return false;
    // Check if at least one parameter is used in the format
    return validParameters.some((param) => value.includes(param));
  },
};

/**
 * Adds the parameter validations to a Yup string schema
 */
export const addParameterValidation = (schema: yup.StringSchema) =>
  schema.test(
    atLeastOneParameterValidator.name,
    atLeastOneParameterValidator.message,
    atLeastOneParameterValidator.test,
  );
